import styled from "styled-components";

export default styled.button`
    align-items: center;
    background: transparent;
    border: none;
    color: ${ ({ color }) => color };
    display: flex;
    font-family: var(--font-mono), monospace;
    font-size: 1rem;
    justify-content: center;
    padding: 0 4px;

    &:hover {
        color: ${ ({ accent }) => accent };
        cursor: pointer;
        opacity: .7;
    }
`;
